import call from '@/utils/api/call'

import {AuthProps} from './foodGrubhubAuthModel'
import {Listing} from './foodGrubhubModel'
import {
  CategoryDetailProps,
  CategoryList,
  MenuItemListing,
  RestaurantDetail,
} from './foodRestaurantDetailModel'

const API_URL = 'https://food.innosearch.ai'

export async function getAuthToken({signal}: {signal?: AbortSignal}) {
  const raw =
    '{"brand":"GRUBHUB","client_id":"beta_UmWlpstzQSFmocLy3h1UieYcVST","scope":"anonymous"}'

  return call
    .post(`${API_URL}/auth`, raw, {
      signal,
      headers: {
        'Accept': '*/*',
        'Accept-Language': 'en-US,en;q=0.9',
        'Content-Type': 'application/json;charset=UTF-8',
        'Cookie':
          '_pxhd=RanLnJhIk15VcHv4Z74uweD2B0MJpaaL9zGZdOQE8s12-aVQ77/ZA8ih7KdrqQ1O6R6EDyGPsx7wnX1mm1NQNw==:PEw6O4zC6ExX6fXNAUX8kIwIpRncuvY9DFKcUQRudEEnwRJlWgl3/IB0dHv8E6ALdyyIjdSDlyjzCi-u0Rmg3pXMVP-eTgFt69aO6-h7tCI=',
      },
    })
    .then(res => {
      const resData = AuthProps(res.data)

      return resData
    })
}

export async function getRestaurants({
  orderMethod,
  locationMode,
  facetSet,
  pageSize,
  hideHateos,
  searchMetrics,
  queryText,
  location,
  preciseLocation,
  geohash,
  includeOffers,
  featureControl,
  sortSetId,
  sponsoredSize,
  countOmittingTimes,
  pageNum,
  signal,
  token,
}: {
  orderMethod: string
  locationMode: string
  facetSet: string
  pageSize: number
  hideHateos: boolean
  searchMetrics: boolean
  queryText: string | null
  location: string
  preciseLocation: boolean
  geohash: string
  includeOffers: boolean
  featureControl: string
  sortSetId: string
  sponsoredSize: number
  countOmittingTimes: boolean
  pageNum: number
  token: string
  signal?: AbortSignal
}) {
  const params = {
    orderMethod,
    locationMode,
    facetSet,
    pageSize,
    hideHateos,
    searchMetrics,
    queryText,
    location,
    preciseLocation,
    geohash,
    includeOffers,
    featureControl,
    sortSetId,
    sponsoredSize,
    countOmittingTimes,
    pageNum,
  }
  return call
    .get(`${API_URL}/restaurants/search/search_listing?`, {
      signal,
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(res => {
      const resData = Listing(res.data)

      return resData
    })
}

export async function getRestaurantDetailInfo({
  signal,
  token,
  restaurantId,
  hideChoiceCategories,
  version,
  variationId,
  orderType,
  hideUnavailableMenuItems,
  hideMenuItems,
  location,
  locationMode,
}: {
  token: string
  restaurantId: string
  hideChoiceCategories: boolean
  version: number
  variationId: string
  orderType: string | null
  hideUnavailableMenuItems: boolean
  hideMenuItems: boolean
  locationMode: string
  location: string
  signal?: AbortSignal
}) {
  const params = {
    hideChoiceCategories,
    version,
    variationId,
    orderType,
    hideUnavailableMenuItems,
    hideMenuItems,
    location,
    locationMode,
  }

  return call
    .get(`${API_URL}/restaurants/${restaurantId}`, {
      signal,
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(res => {
      const resData = RestaurantDetail(res.data)

      return resData
    })
}

export async function getMenuItemCategoryList({
  signal,
  token,
  orderType,
  platform,
  enhancedFeed,
  weightedItemDataIncluded,
  location,
  viewport,
  restaurantId,
}: {
  signal?: AbortSignal
  token: string
  orderType: string
  platform: string
  enhancedFeed: boolean
  weightedItemDataIncluded: boolean
  location: string
  viewport: string
  restaurantId: string
}) {
  const params = {
    orderType,
    platform,
    enhancedFeed,
    weightedItemDataIncluded,
    location,
    viewport,
    restaurantId,
  }

  return call
    .get(`${API_URL}/restaurant_gateway/info/volatile/${restaurantId}`, {
      signal,
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(res => {
      const resData = CategoryList(res.data)

      return resData
    })
}

export async function getMenuItemList({
  signal,
  token,
  time,
  location,
  operationId,
  isFutureOrder,
  restaurantStatus,
  brandUuid,
  isNonRestaurantMerchant,
  merchantTypes,
  orderType,
  pageSize,
  agent,
  weightedItemDataIncluded,
  task,
  rpcVariant,
  platform,
  restaurantId,
  menuItemId,
  dataType,
  searchQuery,
  sortBy,
}: {
  signal?: AbortSignal
  token: string
  time: number
  location: string
  operationId: string
  isFutureOrder: boolean
  restaurantStatus: string
  brandUuid: string
  isNonRestaurantMerchant: boolean
  merchantTypes: string
  orderType: string
  pageSize?: number
  agent: boolean
  weightedItemDataIncluded: boolean
  task: string
  rpcVariant: string
  platform: string
  restaurantId: string
  menuItemId: string
  dataType?: string
  searchQuery?: string
  sortBy?: string
}) {
  const params = {
    time,
    location,
    operationId,
    isFutureOrder,
    restaurantStatus,
    brandUuid,
    isNonRestaurantMerchant,
    merchantTypes,
    orderType,
    pageSize,
    agent,
    weightedItemDataIncluded,
    task,
    rpcVariant,
    platform,
    restaurantId,
    menuItemId,
    dataType,
    searchQuery,
    sortBy,
  }

  return call
    .get(`${API_URL}/restaurant_gateway/feed/${restaurantId}/${menuItemId}`, {
      signal,
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(res => {
      const resData = MenuItemListing(res.data)

      return resData
    })
}

export async function getMenuItemDetail({
  signal,
  token,
  restaurantId,
  menuItemId,
  time,
  hideUnavailableMenuItems,
  orderType,
  locationMode,
  version,
  includeWeightedItemsData,
  location,
}: {
  token: string
  restaurantId: string
  menuItemId: string
  time: number
  hideUnavailableMenuItems: boolean
  orderType: string
  locationMode: string
  version: number
  includeWeightedItemsData: boolean
  location: string
  signal?: AbortSignal
}) {
  const params = {
    time,
    hideUnavailableMenuItems,
    orderType,
    locationMode,
    version,
    includeWeightedItemsData,
    location,
  }

  return call
    .get(`${API_URL}/restaurants/${restaurantId}/menu_items/${menuItemId}`, {
      signal,
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(res => {
      const resData = CategoryDetailProps(res.data)

      return resData
    })
}

export async function getMenuItemsDetail({
  signal,
  token,
  restaurantId,
  menuItemIds,
  time,
  hideUnavailableMenuItems,
  orderType,
  locationMode,
  version,
  includeWeightedItemsData,
  location,
}: {
  token: string
  restaurantId: string
  menuItemIds: string[]
  time: number
  hideUnavailableMenuItems: boolean
  orderType: string
  locationMode: string
  version: number
  includeWeightedItemsData: boolean
  location: string
  signal?: AbortSignal
}) {
  const params = {
    time,
    hideUnavailableMenuItems,
    orderType,
    locationMode,
    version,
    includeWeightedItemsData,
    location,
    menuItemIds,
  }
  return call
    .get(`${API_URL}/restaurants/${restaurantId}/menu_items`, {
      signal,
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(res => {
      const resData = CategoryDetailProps(res.data)

      return resData
    })
}
